import { Node } from '@tiptap/core';

import { getRequiredTitlePlugin } from '../../plugins/getRequiredTitlePlugin';
import { TITLE_NODE_NAME } from './constants';

/*
https://github.com/ueberdosis/tiptap/discussions/3068
https://tiptap.dev/docs/examples/advanced/forced-content-structure
*/

type TOptions = {
  /**
   * Whether this editor holds the start of the document - false while it holds a later part, where
   * the title does not belong.
   */
  holdsDocumentStart: () => boolean;
};

export const TitleNode = Node.create<TOptions>({
  name: TITLE_NODE_NAME,

  content: 'text*',

  marks: '',

  // group: "block",

  defining: true,

  addOptions() {
    return { holdsDocumentStart: () => true };
  },

  addProseMirrorPlugins() {
    return [getRequiredTitlePlugin(this.options.holdsDocumentStart)];
  },

  renderHTML({ HTMLAttributes }) {
    return [`title-node`, HTMLAttributes, 0];
  },
  parseHTML() {
    return [
      {
        tag: 'title-node',
      },
    ];
  },
});

export default TitleNode;
